module.exports = __webpack_public_path__ + "assets/img/d18e1470da8173d77c0d78f8c5ea13bc.svg";